import { createSlice } from '@reduxjs/toolkit';
import { Status } from '.';
import { message } from '@docon/docon-ui-library';
import { createAsyncAction } from '../action';

const getAllUser = createAsyncAction('getAllUser', 'getAllUser');
const deleteUser = createAsyncAction('deleteUser', 'deleteUser');
const sendPassword = createAsyncAction('sendPassword', 'sendPassword');
const sendResetPasswordLink = createAsyncAction('sendResetPasswordLink', 'sendResetPasswordLink');
const addUser = createAsyncAction('addUser', 'addUser');
const getFilteredUser = createAsyncAction('getFilteredUser', 'getFilteredUser');

interface IInitialState {
  isFetchingUsers: boolean;
  isFetchingFilteredUsers: boolean;
  fetchingFilteredUsersError: string;
  userAddStatus: string;
  userDeleteStatus: string;
  sendResetPasswordStatus: string;
  totalUsers: number;
  totalPages: number;
  usersPerPage: number;
  users: any;
}

const initialState: IInitialState = {
  isFetchingUsers: false,
  isFetchingFilteredUsers: false,
  fetchingFilteredUsersError: '',
  userAddStatus: '',
  userDeleteStatus: '',
  sendResetPasswordStatus: '',
  totalUsers: 0,
  totalPages: 1,
  usersPerPage: 20,
  users: [],
};

export const counterSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUserState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getAllUser.pending as any]: (state) => {
      state.isFetchingUsers = true;
    },
    [getAllUser.fulfilled as any]: (state, { payload }) => {
      state.users = payload?.data || [];
      state.totalUsers = state.users?.length;
      // state.totalPages = payload.data?.total_pages;
      state.usersPerPage = state.totalUsers;
      state.isFetchingUsers = false;
    },
    [getAllUser.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingUsers = false;
      }
    },

    [deleteUser.pending as any]: (state) => {
      state.userDeleteStatus = Status.pending;
    },
    [deleteUser.fulfilled as any]: (state) => {
      state.userDeleteStatus = Status.fulfilled;
    },
    [deleteUser.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.userDeleteStatus = Status.rejected;
      }
    },

    [sendPassword.fulfilled as any]: () => {
      message.success('Password sent successfully');
    },
    [sendPassword.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        message.error('Password sent failed');
      }
    },

    [sendResetPasswordLink.fulfilled as any]: (state) => {
      message.success('Reset-Password Link sent successfully');
      state.sendResetPasswordStatus = Status.fulfilled;
    },
    [sendResetPasswordLink.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        message.error('Reset-Password Link sent failed');
        state.sendResetPasswordStatus = Status.fulfilled;
      }
    },

    [addUser.pending as any]: (state) => {
      state.userAddStatus = Status.pending;
    },
    [addUser.fulfilled as any]: (state) => {
      state.userAddStatus = Status.fulfilled;
    },
    [addUser.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.userAddStatus = Status.rejected;
      }
    },

    [getFilteredUser.pending as any]: (state) => {
      state.isFetchingFilteredUsers = true;
    },
    [getFilteredUser.fulfilled as any]: (state, { payload }) => {
      state.isFetchingFilteredUsers = false;
      state.users = payload?.data || [];
      state.totalUsers = state.users?.length;
    },
    [getFilteredUser.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingFilteredUsers = false;
      }
    },
  },
});

const { updateUserState } = counterSlice.actions;
export {
  updateUserState,
  getAllUser,
  deleteUser,
  sendPassword,
  sendResetPasswordLink,
  addUser,
  getFilteredUser,
};
export default counterSlice.reducer;
